export default {
  methods: {
    toggleRedDropdown () {
      this.$refs.redDropdown.classList.toggle('show')
      this.$refs.redSelection.classList.toggle('faded-red')
    },
    toggleGreyDropdown () {
      this.$refs.greyDropdown.classList.toggle('show')
      this.$refs.greySelection.classList.toggle('faded-grey')
    }
  }
}
